/** Canonical analytics event names and helpers shared by browser, server and dashboard. */
export const ANALYTICS_EVENTS = [
  "page_view",
  "button_click",
  "form_start",
  "form_abandon",
  "generate_lead",
  "click_phone",
  "click_email",
  "click_whatsapp",
  "language_switch",
  "scroll_depth",
] as const;
export type AnalyticsEvent = (typeof ANALYTICS_EVENTS)[number];

export const BOT_LABELS = ["human", "suspect", "bot"] as const;
export type BotLabel = (typeof BOT_LABELS)[number];

const BOT_UA = /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|playwright|puppeteer|phantom|preview|facebookexternalhit|bingpreview/i;

export function botLabel(input: { userAgent: string; webdriver: boolean; interacted: boolean }): BotLabel {
  if (input.webdriver || BOT_UA.test(input.userAgent)) return "bot";
  return input.interacted ? "human" : "suspect";
}

export type SourceGroup = "google" | "social" | "direct" | "referral" | "other_search";

export function classifySource(referrer: string, ownHost: string, utmSource?: string | null): SourceGroup {
  const value = (utmSource || "").toLowerCase();
  let host = "";
  try {
    host = referrer ? new URL(referrer).hostname.toLowerCase() : "";
  } catch {
    host = "";
  }
  const probe = value || host;
  if (!probe || (host && host.replace(/^www\./, "") === ownHost.replace(/^www\./, "") && !value)) return "direct";
  if (/google/.test(probe)) return "google";
  if (/facebook|instagram|linkedin|tiktok|pinterest|youtube|twitter|x\.com|^t\.co|whatsapp/.test(probe)) return "social";
  if (/bing|yahoo|duckduckgo|ecosia|qwant/.test(probe)) return "other_search";
  return "referral";
}

/** Strip the language prefix and query so pages group across languages. */
export function normalizePage(pathname: string): string {
  const clean = (pathname.split("?")[0] ?? "").split("#")[0]!.replace(/\/+$/, "") || "/";
  return clean.length > 200 ? clean.slice(0, 200) : clean;
}

export const QUOTE_PATH = /^\/(nl|en|fr)\/offerte\/?$/;
